import { render, staticRenderFns } from "./tablePresensi.vue?vue&type=template&id=18180dd8&scoped=true"
import script from "./tablePresensi.vue?vue&type=script&lang=js"
export * from "./tablePresensi.vue?vue&type=script&lang=js"
import style0 from "./tablePresensi.vue?vue&type=style&index=0&id=18180dd8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18180dd8",
  null
  
)

export default component.exports